import { API_URL } from "@/config";
import type {
  GetPaginatedAutomatedReportsQuery,
  ImportedOrdersFileReadModel,
} from "@generated/tenant/models";
import axios from "axios";
import type { PaginatedImportedOrdersFilesReadModel } from "./types";

const store = {
  namespaced: true,

  actions: {
    async getPaginatedImportedOrdersFiles(
      _: never,
      query: GetPaginatedAutomatedReportsQuery,
    ): Promise<PaginatedImportedOrdersFilesReadModel> {
      const response = await axios.get(`${API_URL}/importedOrdersFiles`, {
        params: query,
      });

      if (response.status !== 200 || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async importOrdersFile(_: never, formData: FormData): Promise<boolean> {
      const response = await axios.post(`${API_URL}/importedOrdersFiles`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 201 || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getImportedOrdersFile(
      _: never,
      importedOrdersFileId: number,
    ): Promise<ImportedOrdersFileReadModel> {
      const response = await axios.get(`${API_URL}/importedOrdersFiles/${importedOrdersFileId}`);

      if (response.status !== 200 || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async confirmImportedOrdersFile(_: never, importedOrdersFileId: number): Promise<boolean> {
      const response = await axios.post(
        `${API_URL}/importedOrdersFiles/${importedOrdersFileId}/confirm`,
      );

      if (response.status !== 200 || typeof response.data !== "object" || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};

export default store;
